export default __webpack_public_path__ + "static/media/r4.a63959ce.jpg";